import contentfulGql from 'js/lib/contentfulGql';

export const getMastertrackPageContentBySlug = contentfulGql`#graphql
fragment MastertrackPartnerInformation on PartnerInformation {
  partnerName
  partnerLogo {
    url(transform: {
      quality: 60
    })
  }
  partnerMonotoneLogo {
    url(transform: {
      quality: 60
    })
  }
  primaryColor
  secondaryColor
}

fragment ExpressionOfInterestContainer on UniversityProgramEoi {
  applyButtonText
  applyButtonUrl
  emailMeButtonText
  programInterestText
  emailMeFormHeaderText
  emailMeConfirmationText
  productEnrollmentFlow
}

fragment CertificateOverview on PremiumCertificatePageContent {
  overviewTitle
  overviewValuePropOne
  overviewValuePropOneIcon
  overviewValuePropTwo
  overviewValuePropTwoIcon
  overviewValuePropThree
  overviewValuePropThreeIcon
  overviewVisual {
    url(transform: {
      quality: 60
    })    
    title
  }
}

fragment CertificateAtAGlance on AtAGlance {
  programStartDate
  programEnrollmentDate
  programFutureDates
  timeFrame
  hoursPerWeek
  tuition
  tuitionCaption
  paymentDetails
  location
  locationCaption
}

fragment EarnCredit on PremiumCertificatePageContent {
  earnCreditTitle
  earnCreditDescription
  earnCreditTowardsText
  earnCreditFinePrint
  stackableDestinationName
  stackableDestinationUrl
  isStackableDestination100Online
}

fragment CertificateFAQs on PremiumCertificatePageContent {
  faqsCollection{
    items {
      answer
      question
    }
  }
  faqContactInfo
}

fragment ProgramDescription on PremiumCertificatePageContent {
  programDescriptionTitle
  programDescriptionSubtitle
  requiredBackground
  skillsYouWillGain
  overviewDescription
}

fragment InstructorsFields on PremiumCertificatePageContent{
  instructorTitle
  instructorsCollection{
    items{
      name
      position
      profilePicture{
        url
      }
    }
  }
}

fragment CoursesInformation on PremiumCertificatePageContent {
  coursesTitle
  coursesListCollection{
    items{
      title
      whatYouWillLearn
      projects
      description
    }
  }
}

fragment ChecklistEnrollment on PremiumCertificatePageContent {
  enrollmentChecklistHeading
  enrollmentChecklistItemsCollection {
    items {
      title
      text
      id
    }
  }
}

fragment MastertrackPageContentFields on PremiumCertificatePageContent {
  slug
  certificateName
  certificateType
  bannerDescription
  disclaimer
  seoInformation {
    metaTitle
    metaDescription
  }
  partnerInformation {
    ...MastertrackPartnerInformation
  }
  expressionOfInterestContainer {
    ...ExpressionOfInterestContainer
  }
  atAGlance {
    ...CertificateAtAGlance
  }
  navigationElementsCollection {
    items {
      ...NavigationElementFields
    }
  }
  ...CertificateOverview
  ...EarnCredit
  ...CertificateFAQs
  ...ProgramDescription
  ...CoursesInformation
  ...InstructorsFields
  ...ChecklistEnrollment
}

fragment NavigationElementFields on NavigationElement {
  route
  label
  id
  isIndexPage
}

query MastertrackPageContent($slug: String!, $locale: String!, $preview: Boolean!) {
  premiumCertificatePageContentCollection(preview: $preview, locale: $locale, where: { slug: $slug }, limit: 1) {
    items {
      ...MastertrackPageContentFields
    }
  }
}
`;

export default { getMastertrackPageContentBySlug };
